import { Request } from '~src/httpClient/serverApi/requests/Request';

export interface IGetSiteEncryptionKeyHistoryParams {}

export interface IGetSiteEncryptionKeyHistoryResult extends Blob {}

export class GetSiteEncryptionKeyHistoryRequest extends Request<IGetSiteEncryptionKeyHistoryParams, IGetSiteEncryptionKeyHistoryResult> {
  constructor(params: IGetSiteEncryptionKeyHistoryParams) {
    super('getSiteEncryptionKeyHistory', params);
    this.headers = {
      'Content-Type': 'text/csv'
    };
  }
}
